export class Report{

  constructor(
    public id: string,
    public offer:{
      id: string,
      status: boolean
    },
    public reportedId: string,
    public reporterId: string,
    public text: string,
    public date: any,
    public states: boolean,
    public replay?: string,
    public created?: {
      status: boolean,
      id: string
    }
  ){}

}
